<template>
  <div class="deluxe-input-manager-base">
    <component
      :is="targetComponent"
      enctype="multipart/form-data"
      method="post"
      :items-id="itemsId"
      :input-param="inputParam"
      :action="action"
    />
  </div>
</template>

<script>
import DeluxeInputA from './components/DeluxeInputA'
export default {
  name: 'DeluxeLp',
  props: {
    postParams: {
      type: [Object, Array],
      default: () => ({})
    },
    // formdata関連
    action: String,
    method: {
      type: String,
      default: 'post'
    },
    itemsId: [Number, String],
    itemScheduleId: [Number, String],
    inputParam: Object,
    categoryId: [Number, String],
    guestId: String,

    // ログインフォームに渡す値
    reissueKey: String,
    returnPath: {
      type: String,
      default: window.location.href
    },
    entryDetailRequired: Boolean,
    isRandSelect: Boolean,
    orderGenre: String,
    expText: String,
    returnParams: {
      type: [Object, Array],
      default: () => ({})
    },
    inputEntryType: [Number, String],
    movieCustomPlanningId: [Number, String],
    isSubscActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    targetComponent(){
      return DeluxeInputA
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.deluxe-input-manager-base {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/deluxe/DeluxeInputManager.vue